/* eslint-disable max-lines-per-function */
import { AutocompleteChanges } from '@equinor/eds-core-react';
import { ComputeCaseDto, ModelAreaDto } from '../../../../../api/generated';
import * as Styled from './SettingSelect.styled';
import { useIsOwnerOrAdmin } from '../../../../../hooks/useIsOwnerOrAdmin';
import { getModelAreaDisplayName } from '../../../../../utils/DisplayNames';
import { Variants } from '@equinor/eds-core-react/dist/types/components/types';
import { normalizeObjectModelAreaId } from '../../../utils/objectCaseUtils';

export const ModelAreaSelect = ({
  modelAreas,
  selectedModelArea,
  disableSelect,
  existingCases,
  caseType,
  setModelArea,
  variant,
  customOptionDisabled,
}: {
  modelAreas: ModelAreaDto[];
  selectedModelArea: ModelAreaDto[] | undefined;
  disableSelect?: boolean;
  existingCases: ComputeCaseDto[];
  caseType?: string;
  setModelArea?: React.Dispatch<
    React.SetStateAction<ModelAreaDto[] | undefined>
  >;
  variant?: Variants;
  customOptionDisabled?: (option: ModelAreaDto) => boolean;
}) => {
  const isOwnerOrAdmin = useIsOwnerOrAdmin();

  const filterDisabled = (option: ModelAreaDto) => {
    return existingCases.some(
      (existingCase) =>
        normalizeObjectModelAreaId(existingCase.modelArea?.modelAreaId) ===
        normalizeObjectModelAreaId(option.modelAreaId),
    );
  };

  return (
    <Styled.AutocompleteRow>
      <Styled.AutoComplete
        label="Model area"
        readOnly={disableSelect}
        options={modelAreas && modelAreas.length > 0 ? modelAreas : []}
        selectedOptions={
          selectedModelArea &&
          selectedModelArea.length > 0 &&
          selectedModelArea[0].modelAreaId !== ''
            ? selectedModelArea
            : selectedModelArea &&
              selectedModelArea.length > 0 &&
              selectedModelArea[0].modelAreaType === 'Whole model'
            ? [
                {
                  modelAreaId: '',
                  modelAreaType: 'Whole model',
                  coordinates: [],
                },
              ]
            : [
                {
                  modelAreaId: '',
                  modelAreaType: '',
                  coordinates: [],
                },
              ]
        }
        onOptionsChange={(changes: AutocompleteChanges<ModelAreaDto>) =>
          setModelArea && setModelArea(changes.selectedItems)
        }
        optionLabel={(modelArea: ModelAreaDto) =>
          getModelAreaDisplayName(modelArea)
        }
        optionDisabled={
          customOptionDisabled
            ? customOptionDisabled
            : !caseType
            ? filterDisabled
            : undefined
        }
        disabled={!isOwnerOrAdmin}
        variant={variant}
      />
    </Styled.AutocompleteRow>
  );
};
